import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api, errMsg } from '../api';
import { Spinner } from '../ui';
import { usePortal } from '../PortalAuth';
import TravelDashboard from '../travel/TravelDashboard';
import TravelLocked from '../travel/TravelLocked';

function TravelEnabled() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    Promise.all([api.get('/travel/countries'), api.get('/travel/news'), api.get('/travel/changes').catch(() => ({ data: [] }))])
      .then(([c, n, ch]) => setData({ countries: c.data, news: n.data, changes: ch.data }))
      .catch((e) => { toast.error(errMsg(e)); setData({ countries: [], news: [], changes: [] }); });
  }, []);
  if (!data) return <Spinner label="Caricamento dati Viaggiare Sicuri…" />;
  return <TravelDashboard countries={data.countries} news={data.news} changes={data.changes} onOpen={(iso3) => navigate(`/portal/travel-security/${iso3}`)} />;
}

export default function TravelSecurityPage() {
  const { user } = usePortal();
  return <div data-testid="travel-page">{user.travel_enabled ? <TravelEnabled /> : <TravelLocked />}</div>;
}
